import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Module, FormData } from 'components/misc'

const PersonalReadBlock = ({ title, person }) => (
  <Module title={title} primary grid>
    <div className="row">
      <div className="col-xs-6">
        <FormData label="First Name">{person && person.firstName}</FormData>
      </div>
      <div className="col-xs-6">
        <FormData label="Last Name">{person && person.lastName}</FormData>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-6">
        <FormData label="Email">{person && person.email}</FormData>
      </div>
      <div className="col-xs-6">
        <FormData label="Phone number">
          {get(person, 'contacts[0].phone')}
        </FormData>
      </div>
    </div>
  </Module>
)

PersonalReadBlock.propTypes = {
  title: PropTypes.string,
  person: PropTypes.object
}

PersonalReadBlock.defaultProps = {
  title: 'Default title'
}

export default PersonalReadBlock
